import React from 'react';
import { Heart, Truck, Shield, Star, Clock, Award } from 'lucide-react';

const About = () => {
  const features = [
    {
      icon: <Truck className="h-8 w-8" />,
      title: "Fast Delivery",
      description: "Same-day delivery in major cities across India"
    },
    {
      icon: <Heart className="h-8 w-8" />,
      title: "Fresh Flowers",
      description: "Hand-picked fresh flowers delivered to your doorstep"
    },
    {
      icon: <Shield className="h-8 w-8" />,
      title: "Quality Guarantee",
      description: "100% satisfaction guarantee on all our products"
    },
    {
      icon: <Clock className="h-8 w-8" />,
      title: "24/7 Support",
      description: "Round-the-clock customer support"
    },
    {
      icon: <Award className="h-8 w-8" />,
      title: "Award Winning",
      description: "Recognized as best flower delivery service"
    },
    {
      icon: <Star className="h-8 w-8" />,
      title: "5-Star Reviews",
      description: "Trusted by thousands of happy customers"
    }
  ];

  const team = [
    { name: "Priya Sharma", role: "Founder & CEO", image: "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=200&h=200&fit=crop" },
    { name: "Rahul Verma", role: "Head Florist", image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&h=200&fit=crop" },
    { name: "Anjali Patel", role: "Customer Service", image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=200&h=200&fit=crop" },
    { name: "Sanjay Kumar", role: "Operations Head", image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=200&h=200&fit=crop" }
  ];

  return (
    <div className="bg-gradient-to-b from-white to-pink-50">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-pink-600 to-pink-800 text-white py-16">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">About Sohkin Flower Gifts</h1>
          <p className="text-xl max-w-3xl mx-auto">
            Spreading joy and happiness through beautiful flowers and thoughtful gifts since 2010.
          </p>
        </div>
      </section>

      {/* Story */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold text-center mb-12">Our Story</h2>
            <div className="prose prose-lg mx-auto">
              <p className="text-lg text-gray-700 mb-6">
                Founded in 2010, Sohkin Flower Gifts began with a simple mission: to help people express their feelings through beautiful flowers and thoughtful gifts. What started as a small flower shop in Delhi has grown into one of India's leading online gift delivery services.
              </p>
              <p className="text-lg text-gray-700 mb-6">
                Our name 'Sohkin' comes from the Sanskrit word meaning 'to bring joy'. And that's exactly what we aim to do - bring joy to our customers through our carefully curated collection of flowers, cakes, chocolates, and personalized gifts.
              </p>
              <p className="text-lg text-gray-700">
                Today, we deliver across 100+ cities in India, with same-day delivery in major metropolitan areas. Our team of expert florists and gift curators work tirelessly to ensure every order is perfect.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-12">Why Choose Us</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {features.map((feature, index) => (
              <div key={index} className="text-center p-6">
                <div className="bg-pink-100 text-pink-600 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  {feature.icon}
                </div>
                <h3 className="text-xl font-semibold mb-2">{feature.title}</h3>
                <p className="text-gray-600">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Team */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-12">Meet Our Team</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8">
            {team.map((member, index) => (
              <div key={index} className="text-center">
                <img
                  src={member.image}
                  alt={member.name}
                  className="w-32 h-32 rounded-full mx-auto mb-4 object-cover"
                />
                <h3 className="text-lg font-semibold">{member.name}</h3>
                <p className="text-pink-600">{member.role}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="py-16 bg-pink-600 text-white">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="text-4xl font-bold mb-2">10K+</div>
              <div className="text-pink-200">Happy Customers</div>
            </div>
            <div>
              <div className="text-4xl font-bold mb-2">100+</div>
              <div className="text-pink-200">Cities Served</div>
            </div>
            <div>
              <div className="text-4xl font-bold mb-2">50K+</div>
              <div className="text-pink-200">Orders Delivered</div>
            </div>
            <div>
              <div className="text-4xl font-bold mb-2">4.8★</div>
              <div className="text-pink-200">Customer Rating</div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;